export enum IncidentsSupport {
  None,
  Summary,
  Collecting
}
